export const STATUS_COLORS = {
  arrival: "#2563eb",
  arrivals: "#2563eb",
  departures: "#7c3aed",
  available: "#059669",
  booked: "#2462EB",
  "on-hold": "#F49D0B",
  "on hold": "#F49D0B",
  "checked-in": "#F97116",
  "checked-out": "#7c3aed",
  cancelled: "#ef4444",
};

export function statusColor(status) {
  return STATUS_COLORS[String(status || "").toLowerCase().trim()] || "#64748b";
}
